<div class="app-date-time-picker">
  <input
    [(ngModel)]="value"
    [owlDateTime]="dt"
    [owlDateTimeTrigger]="dt"
    [disabled]="isDisabled"
    [placeholder]="placeholder"
    [min]="minDate"
    [max]="maxDate"
    (dateTimeChange)="dateTimeChange($event)"
    class="input-date-time-picker"
    readonly
  />
  <div class="icon-calendar"></div>
</div>
<owl-date-time
  #dt="owlDateTime"
  panelClass="date-time-picker-panel"
  [pickerType]="config.pickerType"
  [disabled]="isDisabled"
  (beforePickerOpen)="beforePickerOpen()"
  (afterPickerClosed)="afterPickerClosed()"
>
</owl-date-time>
